import React, {Component} from 'react';
import {connect} from 'react-redux';

import DoctorsAll from './doctors';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';

const mapStateToProps = (state) => ({
  user: state.auth.get('user')
});


class Doctors extends Component {
  renderBreadcrumbs = () => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) return null
    return (
      <Breadcrumbs>
        <li><Link to="/admin/">Головна</Link></li>
        <li><Link to="/admin/doctors">Облікові записи</Link></li>
      </Breadcrumbs>
    )
  };

  render() {
    return (
      <div>
        {this.renderBreadcrumbs()}
        <DoctorsAll/>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Doctors);



// WEBPACK FOOTER //
// ./src/admin/doctors/index.js